import React from 'react';
import {
  HashRouter,
  Route
} from 'react-router-dom';
import TournamentList from './TournamentList';
import RegistrationPage from './RegistrationPage';
import AdminDashboard from './AdminDashboard';
import ParticipantsList from './ParticipantsList';
import LoginPage from './LoginPage';
import TournamentCreator from './TournamentCreator';
import PasswordChange from './PasswordChange';
import ProcessingPayment from './ProcessingPayment';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './app.css';
import TournamentEditor from './TournamentEditor';
import TournamentEmailShipment from './TournamentEmailShipment';
import UserList from './UserList';
import UserCreator from './UserCreator';

class AppComponent extends React.Component {

  render() {
    return (
      <HashRouter>
        <div className="index">
          <Route exact path="/" component={TournamentList} />
          <Route exact path="/tournaments/:id/:action" component={RegistrationPage} />
          <Route exact path="/admin" component={AdminDashboard} />
          <Route exact path="/admin/tournaments/:id/participants" component={ParticipantsList} />
          <Route exact path="/admin/tournaments/:id/edit" component={TournamentEditor} />
          <Route exact path="/admin/tournaments/:id/email-shipment" component={TournamentEmailShipment} />
          <Route exact path="/admin/tournaments/new" component={TournamentCreator} />
          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/password-change" component={PasswordChange} />
          <Route exact path="/processing-payment" component={ProcessingPayment} />
          <Route exact path="/users" component={UserList} />
          <Route exact path="/users/new" component={UserCreator} />
        </div>
      </HashRouter>
    );
  }
}

AppComponent.defaultProps = {
};

export default AppComponent;



// WEBPACK FOOTER //
// ./components/App.js